import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Slider from 'react-slide-out'
import { closeDrawer } from './drawerActions'
import TestDrawer from './TestDrawer'
import OrgSubmissionFormDrawer from './OrgSubmissionFormDrawer'
import LocationDetailDrawer from './LocationDetailDrawer'

const drawerLookup = {
  TestDrawer,
  OrgSubmissionFormDrawer,
  LocationDetailDrawer
}

const DrawerWrapper = () => {
  const dispatch = useDispatch()
  const currentDrawer = useSelector((state) => state.drawers)

  const close = () => {
    dispatch(closeDrawer())
  }

  if (currentDrawer) {
    const { drawerType, drawerProps } = currentDrawer
    const DrawerComponent = drawerLookup[drawerType]
    return (
      <Slider isOpen={true} onOutsideClick={() => close()}>
        <div className='d-flex justify-content-end p-3 bg-light'>
          <button onClick={() => close()} className='close'></button>
        </div>

        <DrawerComponent {...drawerProps} />
      </Slider>
    )
  }
  return <></>
}

DrawerWrapper.propTypes = {}

export default DrawerWrapper
